import { observer, inject } from 'mobx-react';

export default function InjectStore (Component) {
  return inject('store')(observer(Component))
};

export const InjectStoreWithoutObserver = (Component) => {
  return inject('store')(Component)
};
